import React from 'react';

import CircularProgress from '@mui/material/CircularProgress';
import { AspectRatio } from 'react-aspect-ratio';

import { ProgressSkeleton } from './UploadProgress.style';

import type { MediaType } from '@shared/models/media.model';
import type { AttachmentsProps } from 'shared/ui-kit';

type UploadProgressPropsType = {
  attachmentsItem: MediaType;
} & Pick<AttachmentsProps, 'aspectRatio' | 'heightImage'>;
export const UploadProgress = (props: UploadProgressPropsType) => {
  const { aspectRatio, heightImage, attachmentsItem } = props;
  return (
    <AspectRatio ratio={aspectRatio} style={{ ...(heightImage && { height: heightImage }) }}>
      <ProgressSkeleton animation="wave" variant="rectangular" width="100%">
        <CircularProgress variant="determinate" value={attachmentsItem.progress} />
      </ProgressSkeleton>
    </AspectRatio>
  );
};
